import React, { Component } from 'react';

export default class View extends Component {
	constructor(props) {
		super(props);
		this.state = {
			amountSufficientError: null,
			isSubmitting: false, // new state to track submission status
		};
	}

	logEntral = (e) => {
		if (this.state.isSubmitting) return; // prevent further clicks if submitting

		this.setState({ isSubmitting: true }); // disable further clicks
		var valid = false;

		if (this.props.data.amountSufficient == null) {
			this.setState({ amountSufficientError: 'Please Select Yes or No', isSubmitting: false });
		} else if (this.props.data.amountSufficient) {
			this.setState({ amountSufficientError: null });
			this.props.data.Pharmacy_Date = new Date();
			this.props.data.RecordType = '06';
			this.props.data.RequestType = '1';

			fetch(window.location.origin + window.location.pathname + 'logDispense', {
				method: 'POST',
				headers: { "Content-Type": 'application/json' },
				body: JSON.stringify({ data: this.props.data }),
			})
				.then(async (response) => {
					if (response.status === 200) {
						this.props.navigate('D23');
					} else {
						this.props.navigate('D22A');
					}
				})
				.finally(() => this.setState({ isSubmitting: false })); // reset submitting state
		} else {
			this.setState({ amountSufficientError: null, isSubmitting: false });
			this.props.navigate('D24');
		}
	};

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>The member has been authorized for {this.props.data.CaloricUnits} caloric units per month, under Enteral Code {this.props.data.NDCCode.replace('0000B', 'B')} with {this.props.data.RefillsRequested} refills, expiring on {new Date(this.props.data.ExpirationDate).toLocaleDateString()}.</p>

				<p>Is this amount sufficient per written order?</p>
				<div className="toggle">
					<div className={this.props.data.amountSufficient == true ? 'Selected' : 'NotSelected'} onClick={() => { this.props.setData('amountSufficient', true); }}>Yes</div>
					<div className={this.props.data.amountSufficient == false ? 'Selected' : 'NotSelected'} onClick={() => { this.props.setData('amountSufficient', false); }}>No</div>
				</div>
				{this.state.amountSufficientError ? <div className="error">{this.state.amountSufficientError}</div> : ''}

				<p>Caloric Unit(s) is equal to the number of calories per can divided by 100.</p>

				<div className="button" onClick={!this.state.isSubmitting ? this.logEntral : null}>
					{this.state.isSubmitting ? 'Processing...' : 'Continue'}
				</div>
			</div>
		);
	}
}